import { CamelCase } from "./camecase.model";

export enum Permissions {
  CanViewEcgs = 1,
  CanEditInterpretation,
  CanManageNonProUsers,
  CanManageProUsers,
  CanViewReports,
  CanLogIntoPortal,
  CanApproveEcg,
  CanViewSelfClinicsEcgs,
  CanSendEcgsViaMail,
  ShowEcgPreview,
  CanArchiveEcgs,
  IsViewSelfClinicIsAllowed,
  CanManageEntities,
}

export type UserPermissions = Omit<
  Record<CamelCase<keyof typeof Permissions>, boolean>,
  "canManageProUsers"
>;
